import * as React from 'react';
import { Alert, Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import './CPContactingFromWhere.css';

export interface CPContactingFromWhereProps {
    saveContactingFromWhere: (a: string) => void;
}

export interface CPContactingFromWhereState {
    other: string;
    selectedOption: string;
    validationError: boolean;
    validationMessage: string;
}

export default class CPContactingFromWhere extends React.PureComponent<
    CPContactingFromWhereProps,
    CPContactingFromWhereState
> {
    constructor(props: CPContactingFromWhereProps) {
        super(props);
        this.state = {
            other: '',
            selectedOption: 'Google Suche',
            validationError: false,
            validationMessage: TR.cPContactingFromWhere_check_data,
        };
    }

    public render() {
        return (
            <div className="mt-2 mb-4 CPContactingFromWhere">
                <Row>
                    <Col>
                        <h4>{TR.cPContactingFromWhere_connection}</h4>
                    </Col>
                </Row>
                {this.state.validationError ? (
                    <Alert className="validationErrorAlert alert" color="danger">
                        {this.state.validationMessage}
                    </Alert>
                ) : null}
                <Row className="myItem editing">
                    <FormGroup tag="fieldset">
                        <legend>{TR.cPContactingFromWhere_please_choose}</legend>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="google"
                                    value={TR.cPContactingFromWhere_google}
                                    onChange={this.inputHandler}
                                    checked={this.state.selectedOption === TR.cPContactingFromWhere_google}
                                />{' '}
                                {TR.cPContactingFromWhere_google}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="Instagram"
                                    value={TR.cPContactingFromWhere_instagram}
                                    onChange={this.inputHandler}
                                    checked={this.state.selectedOption === TR.cPContactingFromWhere_instagram}
                                />{' '}
                                {TR.cPContactingFromWhere_instagram}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="friends"
                                    value={TR.cPContactingFromWhere_friends}
                                    onChange={this.inputHandler}
                                    checked={this.state.selectedOption === TR.cPContactingFromWhere_friends}
                                />{' '}
                                {TR.cPContactingFromWhere_friends}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="Flyer"
                                    value={TR.cPContactingFromWhere_flyer}
                                    onChange={this.inputHandler}
                                    checked={this.state.selectedOption === TR.cPContactingFromWhere_flyer}
                                />{' '}
                                {TR.cPContactingFromWhere_flyer}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="advertising"
                                    value={TR.cPContactingFromWhere_ads}
                                    onChange={this.inputHandler}
                                    checked={this.state.selectedOption === TR.cPContactingFromWhere_ads}
                                />{' '}
                                {TR.cPContactingFromWhere_ads}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="other"
                                    value={TR.cPContactingFromWhere_other}
                                    onChange={this.inputHandler}
                                    checked={this.state.selectedOption === TR.cPContactingFromWhere_other}
                                />{' '}
                                {TR.cPContactingFromWhere_other}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            {this.state.selectedOption === 'Sonstiges' && (
                                <Input
                                    style={{ border: this.state.validationError ? '1px solid red' : undefined }}
                                    type="text"
                                    name="other"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        this.setState({
                                            other: e.currentTarget.value,
                                        });
                                    }}
                                />
                            )}
                        </FormGroup>
                    </FormGroup>
                </Row>
                <Row>
                    <Col md={12} className="text-right">
                        <Button
                            className="mt-3 mb-1"
                            size="sm"
                            onClick={() => {
                                if (this.state.other.length < 3) {
                                    this.setState({
                                        validationError: true,
                                    });
                                } else {
                                    this.setState({
                                        validationError: false,
                                    });
                                }
                                if (
                                    this.state.selectedOption === TR.cPContactingFromWhere_other &&
                                    !this.state.validationError
                                ) {
                                    this.props.saveContactingFromWhere(this.state.other);
                                } else if (this.state.selectedOption !== TR.cPContactingFromWhere_other) {
                                    this.props.saveContactingFromWhere(this.state.selectedOption);
                                }
                            }}
                        >
                            {TR.cPContactingFromWhere_save}
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }

    private inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ selectedOption: e.target.value });
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPContactingFromWhere.tsx